import React from "react"
import { ExclusiveChoice } from "dash-styled"

interface Props {
    isCrowdActive: boolean
    toggleCrowdActive: (status: boolean) => void
}

export const CrowdSwitch: React.FC<Props> = ({
    isCrowdActive,
    toggleCrowdActive
}: Props) => {
    const selectInHouse = () => toggleCrowdActive(true)
    const selectCrowd = () => toggleCrowdActive(false)

    return (
        <div>
            <ExclusiveChoice
                className="mt-1"
                choices={["super.AI's in-house workers"]}
                selectedIndex={isCrowdActive ? 0 : undefined}
                interactive={true}
                onClick={selectInHouse}
                withPanel={false}
                color="violet"
                testId="in-house"
            />
            <ExclusiveChoice
                className="mt-1"
                choices={["Me, or people I invite"]}
                selectedIndex={!isCrowdActive ? 0 : undefined}
                interactive={true}
                onClick={selectCrowd}
                withPanel={false}
                color="violet"
                testId="invited"
            />
        </div>
    )
}
